import { DateTime } from 'luxon';
import { MIN_SUPPORTED_DATE } from 'utils/date-time';

export enum TabsName {
  MyInsight = 'myInsight',
  Supervisor = 'supervisor'
}

export const hasValidStartDate = (startDate: string): boolean => {
  const sDate = DateTime.fromISO(startDate);
  if (sDate < MIN_SUPPORTED_DATE) {
    return false;
  } else return true;
};

export const getFormattedPercentage = (
  value: number,
  totalValue: number
): number => {
  const p = ((value / totalValue) * 100).toFixed(2);
  return Number(p);
};
